/**
 * 完了メッセージの設定を行う
 * @param {*} response 
 */
exports.set = function (response) {
    // 完了メッセージの表示
    $.each(response.messages, function(i, message) {
        toastr.success(message);
    });
};